interface RadioButtonOption<T> {
  label: string;
  value: T;
}

export enum InvoiceTypeOptions {
  SCHOOL = 'school',
  SELF_PAYMENT = 'self-payment',
}

export const invoiceOptions: RadioButtonOption<InvoiceTypeOptions>[] = [
  {
    label: 'Právnická osoba - škola, organizace',
    value: InvoiceTypeOptions.SCHOOL,
  },
  {
    label: 'Fyzická osoba (samoplátce)',
    value: InvoiceTypeOptions.SELF_PAYMENT,
  },
];
